import {HttpConfig} from './config/http-config.interface';
import {HttpGetParams} from './model/http-get-params.interface';
import {httpGetUrlSerializer} from './misc/http-get-url.serializer';
import {httpDefaultConfig} from './config/http-default.config';
import {defer, Observable} from 'rxjs';

export class HttpClientService {
    private config: HttpConfig = httpDefaultConfig;

    constructor(
        config: HttpConfig
    ) {
        this.config = {...this.config, ...config}
    }

    get<T>(service: string, data: HttpGetParams): Observable<T> {
        return defer(() =>
            fetch(httpGetUrlSerializer(this.config.uri, service, data), {
                method: 'GET',
                mode: 'cors',
                credentials: 'same-origin'
            }).then(response => response.json())
        );
    }
}